<template>
    <span>{{ formatted }}</span>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { dateHumanReadable } from '@src/Common/Helpers/dates';

const props = defineProps<{
    value?: unknown;
}>();

const formatted = computed((): string => {
    if (!props.value || typeof props.value !== 'string') {
        return '';
    }

    return dateHumanReadable(props.value);
});
</script>
